import { on, reducer } from 'ts-action';

import { togglePopup, setError, setLoader, setSuccess, clearErrors, clearNotices, setUrlHistory } from './actions';

import { UIState } from './';

const initialState: UIState = {
    loaders: {
        location: true,
    },
    errors: {},
    notices: {},
    success: {},
    location_filter: { opened: false },
    location_request: { opened: false, payload: { urns: [] } },
    location_request_spaces: { opened: false, payload: { urns: [] } },
    location_request_success: { opened: false },
    sujet_upload_and_check: { opened: false },
    collection: { opened: false },
    urlHistory: [],
};

export default reducer(
    initialState,
    on(togglePopup, (state, { payload: { name, status, payload } }) => ({ ...state, [name]: { opened: status, payload } })),
    on(setError, (state, { payload }) => ({ ...state, errors: { ...state.errors, ...payload } })),
    on(clearErrors, (state, { payload }) => {
        let newErrors = { ...state.errors };

        if (payload) {
            if (newErrors[payload]) delete newErrors[payload];
        } else {
            newErrors = {};
        }

        return { ...state, errors: { ...newErrors } };
    }),
    on(clearNotices, (state, { payload }) => {
        let newNotices = { ...state.notices };

        if (payload) {
            if (newNotices[payload]) delete newNotices[payload];
        } else {
            newNotices = {};
        }

        return { ...state, notices: { ...newNotices } };
    }),
    on(setLoader, (state, { payload }) => ({ ...state, loaders: { ...state.loaders, ...payload } })),
    on(setSuccess, (state, { payload }) => ({ ...state, success: { ...state.success, ...payload } })),
    on(setUrlHistory, (state, { payload }) => {
        if (payload !== state.urlHistory[state.urlHistory.length - 1] || !state.urlHistory.length) {
            return { ...state, urlHistory: [...state.urlHistory, payload] };
        }

        return state;
    })
);
